import { useLanguageMessages } from "~/composables/useLanguageMessage"


type LanguageMessagesResult = {
  language: string
  item: {
    key: string
    value: string
  }[]
}

type i18nMessages = Record<string, string>

type LanguageRow = {
  key: string
  value: string
}

// export default defineI18nLocale(async (locale) => {
//   // Include a cacheKey parameter that's unique to this locale file
//   // This makes the query parameters unique for effective caching
//   const { data } = await useSanityQuery<LanguageMessagesResult[]>(getLanguage, {
//     key: 'da',
//     language: locale,
//     cacheKey: `danish-i18n-${locale}`, // Add a unique parameter that doesn't affect the query but creates a unique cache key
//   })
//   console.log(`danish-i18n-${locale}`)
//   if (!data.value?.length) return {}

//   const { item } = data.value.find((result) => result.language === locale) as LanguageMessagesResult

//   let messages: i18nMessages = {}

//   item.forEach((row: LanguageRow) => {
//     if (!row.key) return

//     messages[row.key] = row.value
//   })

//   return messages
// })


export default defineI18nLocale(async (locale) => {
  return await useLanguageMessages(locale)
})
